import { render, staticRenderFns } from "./siderNetwork.vue?vue&type=template&id=e5146d4c&scoped=true&"
import script from "./siderNetwork.vue?vue&type=script&lang=js&"
export * from "./siderNetwork.vue?vue&type=script&lang=js&"
import style0 from "./siderNetwork.vue?vue&type=style&index=0&id=e5146d4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5146d4c",
  null
  
)

export default component.exports